import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-otp',
  template: `
    <div class="w-full">
      <p-inputotp [formControl]="control" [integerOnly]="true" size="small" />

  @if(props.description){
      <div class="text-sm text-gray-600  pl-1 pt-1">{{props.description}}</div>
  }
    </div>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyOtpComponent extends FieldType {
  get control(): FormControl {
    return this.formControl as FormControl;
  }

  constructor() {
    super();
  }
}
